import { OrderItemViewModel, OrderLineItemViewModel, OrderViewModel } from '@/api/api';
import { dispatchOrderAction } from '@/store/order/order-dispatch';
import { OrderAction } from '@/store/order/order-module-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import ClerkOrderLineItemNoteDialog from './OrderLineItemNoteDialog.vue';

import {
  GetLaneReservationsCaseBottleText,
  GetWarehouseBadgeColor,
  GetLineItemWarehouse
} from '@/utilities/lane-utils';

@Component({
  components: { ClerkOrderLineItemNoteDialog }
})
export default class ClerkOrderLineItems extends Vue {
  readonly GetLaneReservationsCaseBottleText = GetLaneReservationsCaseBottleText;
  readonly GetWarehouseBadgeColor = GetWarehouseBadgeColor;
  readonly GetLineItemWarehouse = GetLineItemWarehouse;

  @Prop({
    type: Array,
    required: true,
    default: () => []
  })
  readonly lineItems!: OrderItemViewModel[];

  @Prop({
    type: Object,
    required: true
  })
  readonly order!: OrderViewModel;

  get expanded() {
    console.log('expanded', this.lineItems);
    return this.lineItems.filter((x) => x.returnReason);
  }

  headers: DataTableHeader[] = [
    { text: 'Varietal', value: 'varietal' },
    { text: 'Status', value: 'status' },
    { text: 'Vintage', value: 'vintage' },
    { text: 'SKU', value: 'partNo' },
    { text: 'Bottle Size / Configuration', value: 'size' },
    { text: '# Cases', value: 'totalCases' },
    { text: 'Lane/s', value: 'laneReservations' },
    { text: 'Actions', value: 'actions_CUSTOM' }
  ];

  openNoteDialog(item: OrderLineItemViewModel): void {
    dispatchOrderAction(OrderAction.showOrderLineItemNoteDialog, item);
  }
}
